import React from "react";

import { SpacerBlockEx as Value } from "@reactivated";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { Separator } from "../Separator";
import { getThemeClass } from "../ThemedModule";

import styles from "./index.module.scss";

interface Props {
    value: Value;
}

/**
 * While normally icky, inline styling makes a ton of sense here. They're
 * leveraging custom properties that already exist without having to link
 * them to classes that would be created just for this purpose, and the
 * usage of these blocks are inextricably linked to these values.
 *
 * So if you are mad at the developer because you have to override a
 * height value...that's on you man
 */
export const SpacerBlock = ({ value }: Props) => {
    const children = value.rule == "yes" ? <Separator /> : undefined;
    const El = value.anchor ? "a" : "div";
    const hasSemanticValue = children || value.anchor;
    return (
        <El
            id={value.anchor ?? undefined}
            className={concatClassNames([
                styles.root,
                getThemeClass(value.module_theme),
            ])}
            style={
                value.height === "no-height"
                    ? undefined
                    : { height: `var(${value.height})` }
            }
            aria-hidden={!hasSemanticValue || undefined}
        >
            {children}
        </El>
    );
};
